import { setContext } from '@apollo/client/link/context';
import { v4 as uuidv4 } from 'uuid';

export const contextLink = setContext(async (request, previousContext) => ({
    headers: {
        'X-CorrelationId': uuidv4(),
    },
}));
